import React from 'react'
import { Field, reduxForm } from 'redux-form'
import TextField from '@material-ui/core/TextField'
import { withStyles, makeStyles } from '@material-ui/core/styles'

const styles = {
  input: {
    color: 'black',
    fontSize: '1rem',
    backgroundColor: 'rgb(0,0,0,0.12)'
  },

  root: {
    color: 'black'
  },
  focused: {
    color: 'black',
    backgroundColor: 'rgb(0,0,0,0.12)',
    '&$focused': {
      color: 'black',
      backgroundColor: 'rgb(0,0,0,0.12)'
    }
  },
  contained: {
    color: 'black',
    backgroundColor: 'var(--palette-error-main)',
    padding: '8px 21px'
  },

  error: {
    color: 'black',
    backgroundColor: 'white',
    padding: '0 0 10px 0',
		margin: '0'
  }
}

const useLabelStyles = makeStyles({
  root: {
    color: 'black'
  },
  focused: {
    color: 'black',

    '&$focused': {
      color: 'black'
    }
  }
})

const useInputStyles = makeStyles({
  root: {
    color: 'black',
    '& input': {
      backgroundColor: 'rgb(0,0,0,.12)'
    }
  },
  contained: {
    color: 'black',
    backgroundColor: 'var(--palette-error-main)',
    padding: '8px 21px'
  },
  error: {
    color: 'black',
    backgroundColor: 'white',
		padding: '0 0 10px 0',
		margin: '0'
  }
})

const renderTextField = ({
  classes,
  label,
  input,
  meta: { touched, invalid, error },
  inputLabelProps,
  inputProps,
  style,
  fullWidth,
  margin,
  variant,
  type,
  labelStyles,
  inputStyles,
  maxLength,
  ...custom
}) => {
  return (
    <div className="global-input-wrapper">
      <TextField
        data-testid='textfield'
        label={label}
        placeholder={label}
        error={touched && invalid || custom.customInvalid}
        helperText={touched && error}
        {...input}
        margin="dense"
        InputLabelProps={{
          classes: {
            root: labelStyles.root,
            focused: labelStyles.focused
          }
        }}
        FormHelperTextProps={{
          classes: { error: classes.error, contained: classes.error, root: classes.error },
          style: { backgroundColor: 'white' }
        }}
        InputProps={{
          ...inputProps,
          inputProps: { maxLength: maxLength, style: { color: 'black' } }
        }}
        style={{}}
        fullWidth
        margin={margin}
        variant={variant}
        {...custom}
        type={type}
        shrink="true"
      />
    </div>
  )
}

const FormTextField = ({
  classes,
  label,
  name,
  inputLabelProps,
  inputProps,
  style,
  fullWidth,
  margin,
  variant,
  type,
  validators,
  maxLength = 255,
  ...other
}) => {
  var labelStyles = useLabelStyles()
  var inputStyles = useInputStyles()
  return (
    <Field
      name={name}
      component={renderTextField}
      label={label}
      inputLabelProps={inputLabelProps}
      inputProps={inputProps}
      style={style}
      fullWidth={fullWidth}
      margin={margin}
      variant={variant}
      type={type}
      validate={validators}
      maxLength={maxLength}
      classes={classes}
      labelStyles={labelStyles}
      inputStyles={inputStyles}
      {...other}
    />
  )
}

export default withStyles(styles)(FormTextField)
